import { render } from "./WorkEvent.vue?vue&type=template&id=4f88e396&scoped=true"
import script from "./WorkEvent.vue?vue&type=script&lang=js"
export * from "./WorkEvent.vue?vue&type=script&lang=js"

import "./WorkEvent.vue?vue&type=style&index=0&id=4f88e396&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f88e396"]])

export default __exports__